import { schema } from 'normalizr';

const billSchema = new schema.Entity('bill');

export default billSchema;
